import "../../../css/Components/DesignSystem/PrimaryButton.css";

const PrimaryButton = ({
  onClick,
  type = "submit",
  disabled = false,
  label = "SAVE",
  className = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`ds-primary-btn ${className}`}
    >
      <div className="Content-SemiBold">{label}</div>
    </button>
  );
};

export default PrimaryButton;
